import React, { useState } from 'react';
import './Services.css';

const Services = ({ language, onContactClick }) => {
  const [selectedService, setSelectedService] = useState(null);

  const t = {
    pt: {
      title: "Os Nossos Serviços",
      description:
        "Na <strong>Focus</strong>, disponibilizamos soluções completas e personalizadas de <strong>fisioterapia</strong>, <strong>fitness e bem-estar</strong>, adaptadas às suas necessidades.",
      services: {
        Fisioterapia: {
          "Avaliação de Fisioterapia": "Avaliação clínica para definição de um plano de tratamento personalizado.",
          "Fisioterapia Musculoesquelética": "Oferecemos avaliações personalizadas para identificar a causa da dor ou das limitações de movimento.",
          "Fisioterapia Desportiva": "Recuperação funcional direcionada a atletas.",
          "Fisioterapia na Saúde da Mulher": "Fisioterapia personalizada direcionada à saúde da mulher.",
          "Reeducação Postural Global (RPG)": "Abordagem especializada para correção postural e tratamento de condições musculoesqueléticas.",
          "Fisioterapia ao domicílio": "Tratamento personalizado no conforto da sua casa."
        },
        "Pilates Clínico": {
          "Acompanhamento individual em Pilates Clínico": "Sessões personalizadas com foco terapêutico.",
          "Aulas de grupo com número limitado de participantes.": "Aulas em grupos reduzidos, com acompanhamento próximo."
        },
        Nutrição: {
          "Consulta Nutricional": [
            "Avaliação nutricional completa",
            "Plano alimentar personalizado"
          ],
          "Reeducação alimentar e boa relação com a comida": "Promoção de hábitos alimentares saudáveis.",
          "Gestão do peso": "Planos para perda, ganho ou manutenção de peso.",
          "Menopausa e saúde da mulher": "Apoio nutricional direcionado às diferentes fases hormonais da mulher.",
          "Nutrição Desportiva": "Plano alimentar orientado para o desempenho físico.",
          "Intolerâncias e Doenças Gastrointestinais": "Acompanhamento para intolerâncias e distúrbios digestivos.",
          "Vegetarianismo e Flexitarianismo": "Planos alimentares para dietas à base de plantas.",
          "Doença Oncológica": "Suporte nutricional durante o tratamento oncológico."
        },
        "Personal Trainer": {
          "Consulta Física": "Avaliação física inicial.",
          "Personal Trainer": "Avaliação individual para definição de metas e plano de treino.",
          "Jiu Jitsu": "Arte marcial que potencia a força física, a flexibilidade e o domínio do autocontrolo através da técnica e disciplina.",
          Kickboxing: ["Aulas em grupo", "Treino individual"]
        },
        "Focus Kids": {
          "Bem-estar Infantil": "Programas desenvolvidos para promover a saúde física e emocional das crianças.",
          "Festas de Aniversário": "O nosso espaço foi idealizado também para proporcionar festas de aniversário únicas e cheias de energia. Oferecemos uma ou duas atividades, como uma animada aula de dança com professor ou um treino divertido de kickboxing. Tudo adaptado à idade e aos interesses particulares das crianças. A nossa equipa ajuda-o a planear uma festa inesquecível, basta entrar em contacto connosco."
        },
        Massagem: {
          "Massagem Relaxamento": "Reduz o stress e promove o bem-estar.",
          "Massagem Terapêutica": "Alívio de tensões musculares e dores.",
          "Drenagem Linfática": "Estimula a circulação linfática e ajuda na eliminação de toxinas.",
          "Massagem Desportiva": "Prepara os músculos para o esforço físico e acelera a recuperação."
        }
      },
      contactUs: "Contacte-nos",
      noInfo: ""
    },
    en: {
      title: "Our Services",
      description:
        "At <strong>Focus</strong>, we provide complete and personalized <strong>physiotherapy</strong>, <strong>fitness, and wellness solutions </strong> tailored to your needs.",
      services: {
        Physiotherapy: {
          "Physiotherapy Assessment": "A clinical evaluation to define a personalized treatment plan.",
          "Musculoskeletal Physiotherapy": "Personalized assessments to identify the cause of pain or movement limitations.",
          "Sports Physiotherapy": "Functional recovery tailored for athletes.",
          "Women's Health Physiotherapy": "Personalized care focused on women’s health.",
          "Global Postural Reeducation (GPR)": "Specialized approach to improve posture and treat musculoskeletal conditions.",
          "Home Physiotherapy": "Personalized treatment delivered in the comfort of your home."
        },
        "Clinical Pilates": {
          "One-on-one Clinical Pilates": "Personalized therapeutic sessions focused on your needs.",
          "Small Group Classes": "Limited group sizes to ensure closer guidance and support."
        },
        Nutrition: {
          "Nutrition Consultation": [
            "Comprehensive nutritional assessment",
            "Personalized meal plan"
          ],
          "Healthy Eating Habits": "Helping you build a positive relationship with food.",
          "Weight Management": "Plans for weight loss, gain, or maintenance.",
          "Menopause & Women's Health": "Nutritional support for different hormonal stages.",
          "Sports Nutrition": "Nutrition plans to support physical performance.",
          "Intolerances & Digestive Conditions": "Guidance for food intolerances and digestive disorders.",
          "Vegetarian & Flexitarian Diets": "Plant-based plans tailored to your needs.",
          "Oncology Nutrition": "Nutritional support during cancer treatment."
        },
        "Personal Training": {
          "Physical Assessment": "An initial evaluation to understand your current fitness level.",
          "Personal Trainer": "One-on-one support to set goals and build a customized workout plan.",
          "Jiu Jitsu": "A martial art that enhances physical strength, flexibility, and self-discipline through technique and focus.",
          Kickboxing: ["Group Classes", "Private Sessions"]
        },
        "Focus Kids": {
          "Child Well-being": "Programs designed to support children's physical and emotional health.",
          "Birthday Parties": "Planning your child’s birthday? Our space is made for fun, energy, and memories they won’t forget! From lively dance sessions to action-packed kickboxing classes, Contact us today to start planning a birthday they’ll never forget."
        },
        Massage: {
          "Relaxation Massage": "Reduces stress and promotes overall well-being.",
          "Therapeutic Massage": "Relieves muscle tension and pain.",
          "Lymphatic Drainage": "Stimulates lymphatic circulation and supports toxin elimination.",
          "Sports Massage": "Prepares muscles for physical exertion and speeds up recovery."
        }
      },
      contactUs: "Contact Us",
      noInfo: ""
    }
  }[language];

  const serviceKeys = Object.keys(t.services);

  return (
    <div className="services-container">
      <div className="initial-view">
        <p
          className="initial-description"
          dangerouslySetInnerHTML={{ __html: t.description }}
        />
        <ul className="horizontal-navbar">
          {serviceKeys.map((service) => (
            <li
              key={service}
              onClick={() => setSelectedService(service)}
              className={`nav-item ${selectedService === service ? 'active' : ''}`}
            >
              {service}
            </li>
          ))}
        </ul>
      </div>

      {selectedService && (
        <div className="services-grid">
          {t.services[selectedService] && typeof t.services[selectedService] === 'object' ? (
            <>
              {Object.entries(t.services[selectedService]).map(([key, value]) => (
                <div key={key} className="service-card">
                  <h4>{key}</h4>
                  {Array.isArray(value) ? (
                    <ul>
                      {value.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{value || t.noInfo}</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <p className="placeholder-text">{t.noInfo}</p>
          )}
        </div>
      )}

      <div className="contact-button-alone">
        <button className="contact-cta-button" onClick={onContactClick}>
          {t.contactUs}
        </button>
      </div>
    </div>
  );
};

export default Services;
